import React from 'react';
import { CustomCols } from '../../live/Live';
import { MAX_COLUMNS } from '../../data/constants';
import { useLayout } from '../../UISettingsProvider';
import MessageInfo from '../../common/MessageInfo';
import { getLabel } from '../../data/labels';

export default function NoResults() {
    const layout = useLayout();

    return (
        <CustomCols.Provider value={MAX_COLUMNS}>
            <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
                <div className="contenitore-schedine-sport">
                    <div className="competizione-interna unaColonna">
                        <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin tablesExpanded">
                            <MessageInfo message={getLabel('general.no_results')} />
                        </div>
                    </div>
                </div>
            </div>
        </CustomCols.Provider>
    );
}
